module.exports = __webpack_public_path__ + "static/media/aci.5756b132.png";